
























import { Component, Vue } from "vue-property-decorator";
import { mapState, } from "vuex";
import { ScheduleView } from "@/store/modules/enums";


@Component({
    computed: {
        ...mapState("schedule", ["view", "list", "statusCount"]),
    },
})
export default class Pager extends Vue {
    view!: ScheduleView;
    list!: any;
    statusCount!: any;


    get ScheduleView() {
        return ScheduleView;
    }

    get totalStatus() {
        return this.statusCount.map((s) => s.count).filter((v, i, a) => a.indexOf(v) === i).reduce((accumulator, value) => accumulator + value, 0);
    }

    isSelected(value) {
        return this.list.filter.statusList.filter(s => s == value).length || this.list.filter.statusList.length ==0 ? true : false;
    }

    //total = this.statusCount.map((s) => s.count).filter((v, i, a) => a.indexOf(v) === i);

    setStatusFilter(value: number) {
       var status = value? [value]: [];
        this.$store.commit("schedule/SET_STATUS_FILTER", status);
        //this.$store.commit("schedule/SET_STATUS_FILTER", [value]);
    }
    
}
